import UserRoles from 'constants/UserRoles';

export const NOTIFICATIONS_TYPES = {
    clientInvitationAccept: 'clientInvitationAccept',
    clientInvitationDecline: 'clientInvitationDecline',
    clientNewApplication: 'clientNewApplication',
    resourceInterviewCancellation: 'resourceInterviewCancellation',
    resourceNewInvitation: 'resourceNewInvitation',
    resourceApplicationApprove: 'resourceApplicationApprove',
    resourceInterviewInThreeDays: 'resourceInterviewInThreeDays',
    resourceInterviewInOneDay: 'resourceInterviewInOneDay',
    resourceInterviewRescheduled: 'resourceInterviewRescheduled',
    resourceMoneyRelease: 'resourceMoneyRelease',
    resourceOpenedDispute: 'resourceOpenedDispute',
    resourceDisputeResponse: 'resourceDisputeResponse',
    clientDisputeResponse: 'clientDisputeResponse',
    disputeResolution: 'disputeResolution',
    resourceInterviewFire: 'resourceInterviewFire',
    clientReportUploaded: 'clientReportUploaded',
    waitingRoomReady: 'waitingRoomReady',
    resourceInterviewRescheduledMultiple: 'resourceInterviewRescheduledMultiple',
    resourceHomeworkReminder: 'resourceHomeworkReminder',
    clientHomeworkUploaded: 'clientHomeworkUploaded',
    outdatedKycStatus: 'outdatedKycStatus',
    sheduledEmail: 'sheduledEmail',
    humanTranscriptsReady: 'humanTranscriptsReady',
    recordingReady: 'recordingReady',
    machineTransriptReady: 'machineTransriptReady',
    invitationSent: 'invitationSent',
    memberDeleted: 'memberDeleted',
    roleDeletionFailed: 'roleDeletionFailed',
    roleDeletionSuccess: 'roleDeletionSuccess',
    cancelInvitation: 'cancelInvitation',
    roleChanged: 'roleChanged',
    permissionNotAllowed: 'permissionNotAllowed',
    constantReload: 'constantReload',
    newMessage: 'newMessage',
    interviewPaidByWireTransfer: 'interviewPaidByWireTransfer',
};

const ClientTypesTooltips = [
    'notifications:tooltipTypes.client.newApplication',
    'notifications:tooltipTypes.client.applicationCancelled',
    'notifications:tooltipTypes.client.invitationAccepted',
    'notifications:tooltipTypes.client.invitationDeclined',
    'notifications:tooltipTypes.client.disputeResponse',
    'notifications:tooltipTypes.client.disputeResolution',
    'notifications:tooltipTypes.client.reportUpload',
];

const ResourceTypesTooltips = [
    'notifications:tooltipTypes.resource.newInvitation',
    'notifications:tooltipTypes.resource.applicationApprove',
    'notifications:tooltipTypes.resource.interviewCancelled',
    'notifications:tooltipTypes.resource.interviewRescheduled',
    'notifications:tooltipTypes.resource.fired',
    'notifications:tooltipTypes.resource.paymentReleased',
    'notifications:tooltipTypes.resource.disputeOpened',
    'notifications:tooltipTypes.resource.disputeResponse',
    'notifications:tooltipTypes.resource.disputeResolution',
];

export const TOOLTIP_TYPES_LIST = {
    [UserRoles.companyAdmin]: ClientTypesTooltips,
    [UserRoles.respondent]: ResourceTypesTooltips,
    [UserRoles.translator]: ResourceTypesTooltips,
    [UserRoles.moderator]: ResourceTypesTooltips,
};
